var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('heading'),_c('payments-table',{scopedSlots:_vm._u([{key:`empty-search`,fn:function(){return [_vm._v("   ")]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }